import { addDoc, collection } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from '../../../../config/firebase';
import { getAllMaterias } from '../../../counts/utils';

export const ModalAddExam = ({ isOpen, closeModal, refresExams }) => {

    const [formData, setFormData] = useState({
        nombre: '',
        area: '',
        descripcion: '',
        materias: [],
        documentacion: [],
        recursos: [],
        estado: '',
        fecha: '',
        visible: false,
    });

    const [selectedMateria, setSelectedMateria] = useState('');
    const [documentacionInput, setDocumentacionInput] = useState('');
    const [materias, SetMaterias] = useState([]);
    const [recursoInput, setRecursoInput] = useState({ nombre: '', url: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const dataMaterias = await getAllMaterias();
                const materias = dataMaterias.map(materia => ({
                    id: materia.id,
                    nombre: materia.nombre
                }));
                SetMaterias(materias)
            } catch (error) {
                console.error('Error fetching materias: ', error);
            }
        };

        fetchData();
        // refreshExam();
    }, []);

    const handleSelectMaterias = (e) => {
        const selectedId = e.target.value;
        const selectedMateria = materias.find(materia => materia.id === selectedId);
        if (selectedMateria) {
            const materiaConIdMayuscula = {
                ...selectedMateria,
                Id: selectedMateria.id,
            };

            if (!formData.materias.some(materia => materia.Id === materiaConIdMayuscula.Id)) {
                setFormData({
                    ...formData,
                    materias: [...formData.materias, materiaConIdMayuscula],
                });
            } else {
                alert('Materia ya agregada.');
            }

            setSelectedMateria('');
        }
    };

    const agregarDocumentacion = () => {
        if (documentacionInput) {
            setFormData({
                ...formData,
                documentacion: [...formData.documentacion, documentacionInput],
            });
            setDocumentacionInput('');
        }
    };

    const agregarRecurso = () => {
        if (recursoInput.nombre && recursoInput.url) {
            setFormData({
                ...formData,
                recursos: [...formData.recursos, recursoInput],
            });
            setRecursoInput({ nombre: '', url: '' });
        }
    };

    const handleRecursoChange = (e) => {
        const { name, value } = e.target;
        setRecursoInput({
            ...recursoInput,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const docRef = await addDoc(collection(db, 'Exam'), {
                ...formData,
            })

            alert('Documentacion agregada con ID: ' + docRef.id);
            refresExams();

        } catch (error) {
            alert("Error al guardar los datos :" + error);
            console.log(error);
        }
        closeModal();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg w-11/12 max-w-full h-9/10 ">
                <p className="text-xl font-bold mb-4">Agregar Examen</p>
                <form onSubmit={handleSubmit} className='h-9/10 overflow-y-auto'>
                    {/* Campos Generales */}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">Nombre</label>
                            <input
                                type="text"
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleInputChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder="Introduce el nombre"
                            />
                        </div>
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">Área</label>
                            <input
                                type="text"
                                name="area"
                                value={formData.area}
                                onChange={handleInputChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder="Introduce el área"
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-gray-700 text-sm font-bold mb-2">Descripción</label>
                            <input
                                type="text"
                                name="descripcion"
                                value={formData.descripcion}
                                onChange={handleInputChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder="Introduce la descripción"
                            />
                        </div>
                    </div>

                    {/* Materias */}
                    <div className="flex mb-4">
                        <div className="flex-1">
                            <label className="block text-gray-700 text-sm font-bold mb-2">Materias</label>
                            <select
                                value={selectedMateria}
                                onChange={handleSelectMaterias}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            >
                                <option value="">Seleccionar materia</option>
                                {materias.map((materia) => (
                                    <option key={materia.id} value={materia.id}>
                                        {materia.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Tabla de materias agregadas */}
                        <div className="ml-4" style={{ width: '70%', maxHeight: '150px', overflowY: 'auto' }}>
                            <table className="min-w-full border">
                                <thead>
                                    <tr>
                                        <th className="border px-2 py-1">Materias agregadas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.materias.map((materia, index) => (
                                        <tr key={index}>
                                            <td className="border px-2 py-1">{materia.id} - {materia.nombre}</td>
                                            {/* <td className="border px-2 py-1"></td> */}
                                            <td className="border px-2 py-1">
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        const nuevasMaterias = formData.materias.filter((_, i) => i !== index);
                                                        setFormData({ ...formData, materias: nuevasMaterias });
                                                    }}
                                                    className="text-red-500"
                                                >
                                                    Eliminar
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Documentación (array) */}
                    <div className="flex mb-4">
                        <div className="flex-1">
                            <label className="block text-gray-700 text-sm font-bold mb-2">Documentación</label>
                            <input
                                type="text"
                                value={documentacionInput}
                                onChange={(e) => setDocumentacionInput(e.target.value)}
                                className="shadow appearance-none border rounded w-full mb-2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder="Agregar documentación"
                            />
                            <button
                                type="button"
                                className="text-blue-500 hover:underline mb-2"
                                onClick={agregarDocumentacion}
                            >
                                Agregar documento
                            </button>
                        </div>

                        {/* Tabla de documentación agregada */}
                        <div className="ml-4" style={{ width: '70%', maxHeight: '150px', overflowY: 'auto' }}>
                            <table className="min-w-full border">
                                <thead>
                                    <tr>
                                        <th className="border px-2 py-1">Documentación</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.documentacion.map((doc, index) => (
                                        <tr key={index}>
                                            <td className="border px-2 py-1">{doc}</td>
                                            <td className="border px-2 py-1">
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        const nuevaDocumentacion = formData.documentacion.filter((_, i) => i !== index);
                                                        setFormData({ ...formData, documentacion: nuevaDocumentacion });
                                                    }}
                                                    className="text-red-500"
                                                >
                                                    Eliminar
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Recursos (array) */}
                    <div className="flex mb-4">
                        <div className="flex-1">
                            <label className="block text-gray-700 text-sm font-bold mb-2">Recursos</label>
                            <div className="mb-2">
                                <label className="block text-gray-700 text-sm font-bold mb-1">Nombre</label>
                                <input
                                    type="text"
                                    name="nombre"
                                    value={recursoInput.nombre}
                                    onChange={handleRecursoChange}
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    placeholder="Nombre del recurso"
                                />
                            </div>
                            <div className="mb-2">
                                <label className="block text-gray-700 text-sm font-bold mb-1">URL</label>
                                <input
                                    type="text"
                                    name="url"
                                    value={recursoInput.url}
                                    onChange={handleRecursoChange}
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    placeholder="URL del recurso"
                                />
                            </div>
                            <button
                                type="button"
                                className="text-blue-500 hover:underline"
                                onClick={agregarRecurso}
                            >
                                Agregar recurso
                            </button>
                        </div>

                        {/* Tabla de recursos agregados */}
                        <div className="ml-4" style={{ width: '70%', maxHeight: '150px', overflowY: 'auto' }}>
                            <table className="min-w-full border">
                                <thead>
                                    <tr>
                                        <th className="border px-2 py-1">Nombre</th>
                                        <th className="border px-2 py-1">URL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.recursos.map((recurso, index) => (
                                        <tr key={index}>
                                            <td className="border px-2 py-1">{recurso.nombre}</td>
                                            <td className="border px-2 py-1">{recurso.url}</td>
                                            <td className="border px-2 py-1">
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        const nuevosRecursos = formData.recursos.filter((_, i) => i !== index);
                                                        setFormData({ ...formData, recursos: nuevosRecursos });
                                                    }}
                                                    className="text-red-500"
                                                >
                                                    Eliminar
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Estado y Fecha */}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">Estado</label>
                            <input
                                type="text"
                                name="estado"
                                value={formData.estado}
                                onChange={handleInputChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder="Introduce el estado"
                            />
                        </div>
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">Fecha</label>
                            <input
                                type="date"
                                name="fecha"
                                value={formData.fecha}
                                onChange={handleInputChange}
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            />
                        </div>
                    </div>

                    {/* Checkbox para visible */}
                    <div className="flex items-center mb-4">
                        <input
                            type="checkbox"
                            name="visible"
                            checked={formData.visible}
                            onChange={() => setFormData({ ...formData, visible: !formData.visible })}
                            className="mr-2"
                        />
                        <label className="text-gray-700 text-sm">Visible</label>
                    </div>

                    <div className="flex justify-end">
                        <button
                            type="button"
                            className="mr-2 bg-gray-400 text-white py-2 px-4 rounded"
                            onClick={closeModal}
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
                        >
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
